import { Component, OnInit, Input } from '@angular/core';
import { EmailSmsTemplateModel } from '../shared/models/email-sms-template-model';
import { EmailSmsTemplateDataModel } from '../shared/models/email-sms-template-data-model';
import { MessageInnerType } from '../shared/models/message-inner-type.enum';
import { EmailSmsTemplatesListComponent } from '../email-sms-templates-list/email-sms-templates-list.component';
//import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'hr-email-tab-templates-list',
  templateUrl: './email-tab-templates-list.component.html',
  styleUrls: ['./email-tab-templates-list.component.less'],
  standalone: false,
})
export class EmailTabTemplatesListComponent implements OnInit {
  private _emailTemplateData: EmailSmsTemplateModel[];

  public emailTemplates: { [innerType: string]: EmailSmsTemplateModel[] };
  public innerTypes: string[];

  public messageInnerTypes = MessageInnerType;
  @Input() set emailTemplateData(emailTemplateData: EmailSmsTemplateModel[]) {
    if (emailTemplateData) {
      this._emailTemplateData = emailTemplateData;

      emailTemplateData.forEach((e) => {
        let innerType = e.messageInnerType;
        if (!this.emailTemplates[innerType]) {
          this.emailTemplates[innerType] = [];
          this.innerTypes.push(this.messageInnerTypes[innerType]);
        }
        this.emailTemplates[innerType].push(e);
      });
    }
  }
  get emailTemplateData(): EmailSmsTemplateModel[] {
    return this._emailTemplateData;
  }

  public isHidden: boolean;
  public emailTemplate: string;
  public emailTemplateTitle: string;

  constructor() {
    this.isHidden = true;
    this.emailTemplates = {};
    this.innerTypes = [];
  }

  ngOnInit() {}

  public onClick(title: string, content: string) {
    if (content != this.emailTemplate && title != this.emailTemplateTitle) {
      this.emailTemplateTitle = title;
      this.emailTemplate = content;
      this.isHidden = this.isHidden ? false : this.isHidden;
    } else {
      this.isHidden = !this.isHidden;
    }
  }

  public onBack() {
    this.isHidden = true;
  }
}
